'use strict';

const shared_genericError = require('./shared/genericError.js');
const shared_configurationError = require('./shared/configurationError.js');
const shared_notFoundError = require('./shared/notFoundError.js');
const shared_timeoutError = require('./shared/timeoutError.js');
const shared_validationError = require('./shared/validationError.js');
const shared_unknownError = require('./shared/unknownError.js');
const shared_http = require('./shared/http.js');
const index_js = require('@cian/core/result/index.js');



exports.GenericError = shared_genericError.GenericError;
exports.ConfigurationError = shared_configurationError.ConfigurationError;
exports.NotFoundError = shared_notFoundError.NotFoundError;
exports.TimeoutError = shared_timeoutError.TimeoutError;
exports.ValidationError = shared_validationError.ValidationError;
exports.UnknownError = shared_unknownError.UnknownError;
exports.HttpBadStatusCodeError = shared_http.HttpBadStatusCodeError;
exports.HttpCancelError = shared_http.HttpCancelError;
exports.HttpTimeoutError = shared_http.HttpTimeoutError;
Object.defineProperty(exports, "Err", {
	enumerable: true,
	get: () => index_js.Err
});
Object.defineProperty(exports, "Ok", {
	enumerable: true,
	get: () => index_js.Ok
});
//# sourceMappingURL=index.js.map
